import { React } from '@@commons';
import { DatePicker as SharedDatePicker } from '@inwink/datepicker';
import { dp } from '@inwink/datepicker/datepicker';

export class DatePicker extends React.PureComponent<dp.DatePickerProps, any> {
    render() {
        return <SharedDatePicker {...this.props} />;
    }
}
